var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_a_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M419,104.9C419,104.9,419,104.8,419,104.9C419,104.8,419,104.9,419,104.9 C418.7,105,418.7,105.1,419,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M475.6,177.3c-1.5-4.3-3.5-8.2-7.6-10.9c5.8-1.8,15.6-1.8,21.5,0.8c-1.9-9.1-13.4-11.1-22.1-11.9 c5.7-7.7,3.7-18.6-1.7-26.6c-1.5,5.3-4.9,10.1-9.9,13.8c9-19.4,3.8-48.4-18.8-59c-0.1,9-8.7,18.8-17.9,21.4c0,0,0,0,0,0.1 c-0.3,0.2-0.3,0.2,0,0h0.1c9.8-11.1,1.9-24.6-10.1-32.1c-1.4,11.4-10.3,23.7-21.7,29.5c3-9.8,0.6-27.1-11.2-33.1 c-1.9,13.6-20.6,20.9-32.9,24.8c-17.4,5.5-37.5,4.8-54.9,10.6c-17.8,6-32.9,22.1-30.8,38.3c-4.3-6.1-8.5-11.6-5.1-18.6 c-14.9,8.5-21.3,28.9-10,40.4c-14.2,6.1-12.9,20.1-11.2,32.2c2.4,16.5,8.3,36.3,19,54.3c1.1,1.8,3.6,7.7,4.8,9.3 c-1.5-14.1,3.5-42,6.3-56.7c3-15.6,5.5-30.5,26.3-31.7c10.5-0.6,22.7,3.2,32.6,4.8c9.1,1.4,24.7,3.2,34.4,2.7 c19-1,30.2-4.5,45.9-8.8c21.9-5.9,21.2-7.5,34.4,8.2c12.1,14.4,20,42.8,21.7,59.8c1,10,2,22,6.8,30.1 C465,241.1,491.1,221.5,475.6,177.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M419,104.9C419,104.9,419,104.8,419,104.9C419,104.8,419,104.9,419,104.9 C418.7,105,418.7,105.1,419,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M432.2,163.2c14.9,1,34.5-12.9,37.7-25.6c-0.9-3.2-2.3-6.2-4.2-8.9c-1.5,5.3-4.9,10.1-9.9,13.8 c0-0.1,0.1-0.1,0.1-0.2C449.8,151.4,441,161.3,432.2,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M432.1,163.2C432.1,163.2,432.2,163.2,432.1,163.2C432.2,163.2,432.1,163.2,432.1,163.2 C431.9,163.2,431.9,163.2,432.1,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M435.5,118.3c-15.2,13.6-33.3,21.5-54.1,25.4c-24.1,4.5-47.4,0.2-71.6-1.1c-11.3-0.6-22,0.8-31.9,5.7 c-6.2,3.1-16.3,9.6-19,16.4c6.4-5,13.4-7.9,23.2-8.2c21-0.6,40.1,5.3,61,5.3c22.3,0,44.3-1.1,63.4-12 c14.8-8.5,32.2-24.2,35.6-39.7C440.9,113.2,438.2,116,435.5,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M362.1,105.7c10.3-8.8,18.3-21.8,17.3-34.3c-1-0.8-2.1-1.6-3.3-2.2c-0.2,1.1-0.4,2.1-0.8,3 c-0.2,1.8-0.6,3.4-1.3,5.3c-3.2,7.9-9.7,15.2-17.7,20.2c-10.3,6.4-24.8,8.2-37.1,9.6c-12.7,1.4-26.1,4.3-38.4,7.1 c-9.8,2.3-15.7,7.4-20.8,14.1c-1.2,2.7-2.1,5.6-2.4,8.4c12.3-11.2,33.8-12.8,50.1-15.4C324.8,119,348.7,117.2,362.1,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M295.1,137.2c3.1-0.6,6.2-1,9.3-1.4c35.4-3.4,82.4-1.3,100.9-32.8c1.4-2.4,2.5-5.1,3.2-7.9 c-1.6,2.3-3.4,4.5-5.3,6.5c-23.7,23.3-61.1,22.3-93.9,25.5c-3.2,0.4-6.4,1-9.6,1.6c-18.1,3.5-34.5,10.5-42.1,26.4 C267.8,144.8,281,139.9,295.1,137.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle1D);
export default __webpack_public_path__ + "static/media/man_hairstyle_1d.de07499aeefe3624365881e434703428.svg";
export { ForwardRef as ReactComponent };